<div class="details-container">

  <div class="details-header" style="background: url(assets/images/slough-sch2.png);">
      
    <div class="details-banner">
        <h1>Slough Grammar School</h1>
        <h2>11 Plus (11+) Exam Information</h2>
    </div>
</div>


<div class="details-publisher">
  <span><strong>Published by - SEHYOG Academy</strong></span>
</div>

<div class="details-content">

  <div class="details-section">

    <h3>Introduction</h3>

    <div class="spacer"></div>

    <p>Grammar school consortia in the UK are collaborative groups of grammar schools that work together to administer entrance exams for admission to their schools. They are typically formed by a group of grammar schools in a particular area or region, who have come together to create a common entrance examination. This test is known as the 11+ or eleven plus exam, and is taken by students seeking Year 7 entry into these selective schools. <br> <br>

 

      Ever since its founding, the Slough Grammar School Consortium has played a crucial role in the selective education system that caters for pupils in Slough, providing a standardised process for admitting students based on their academic abilities. <br> <br>
      
       
      
      All the schools in the Slough Grammar School Consortium use the same entrance test, ensuring the admissions process is fair. Therefore, students only need to sit the test once, even if they are applying to multiple schools within the consortium. <br> <br>
      
       
      
      The purpose of the Slough Consortium is to streamline the admissions process for its grammar schools and ensure consistency in the selection process. All grammar schools in the Slough Consortium share their resources, expertise and administrative efforts, endeavouring to provide equal opportunities for students from diverse backgrounds to pursue a high-quality education. </p>


      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Complete List of Grammar Schools in Slough</h2>

      <div class="spacer"></div>

      <p>There are currently four grammar schools in the Slough Grammar School Consortium:</p>

      <div class="spacer"></div>

      <table>
        <tr>
          <th>School Name</th>
        </tr>
        <tr *ngFor="let school of schools">
          <td><a [href]="school.url" target="_blank">{{ school.name }}</a></td>
        </tr>
      </table>



    <div class="spacer"></div>

    <h2>11 Plus (11+) Exam Information for Slough Grammar Schools
    </h2>

    <div class="spacer"></div>

    <p>The results of the Slough Consortium entrance exam are used as a common basis for admission decisions among the participating grammar schools. Students who perform well on the exam have the opportunity to be considered for admission to multiple schools within the consortium, increasing their chances of securing a place at a grammar school of their choice. Here are some key details about the Slough 11+ exam:</p>

    <div class="spacer"></div>



    <p><strong>Registration closing date: </strong> June</p>
    <p><strong>Common Application Form (CAF) closing date:</strong> October</p>
    <p><strong>Admissions info:</strong> office&#64;suttongrammar.sutton.sch.uk, 020 8642 3821</p>
    <p><strong>Exam date:</strong>Boys’ Grammar</p>
    <p><strong>Exam board type:</strong>GL Assessment</p>
    <p><strong>Number of places in Year 7</strong>135</p>
    <p><strong>Pass mark: </strong>Aim for 80%+ in our practice tests. See below for more details.</p>
    <p><strong>Results date: </strong> October</p>
    <p><strong>Allocations date:</strong>March</p>
    <p><strong>Admissions Info:</strong>01753 875728</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Slough Grammar Schools 11 Plus (11+) Admissions</h2>

    <div class="spacer"></div>

    <p>All Year 7 places in Slough grammar schools are determined by pupil performance in the 11 Plus exam. Each individual school typically hosts Open Events, providing parents and prospective students with the opportunity to take a tour of the campus, meet staff members and talk to current pupils. <br> <br>

 

      Year 7 admissions to Slough grammar schools are coordinated through the Slough Consortium of Grammar Schools and you must register your child using an online portal ahead of their 11+ exam date in September.</p>

      <div class="spacer"></div>
      <div class="spacer"></div>


      <h2>How to Register for the Slough Grammar Schools 11 Plus (11+) Exam</h2>

      <p>To apply for a Year 7 place at a Slough grammar school, you must register your child with the Slough Consortium prior to the deadline in June of the year preceding entry. The next step is to complete a Common Application Form (CAF) before October, which can be done online via the Slough County Council website.</p>

      <div class="spacer"></div>
      <div class="spacer"></div>

      <h2>Slough Grammar Schools 11 Plus (11+) Exam Format</h2>
      <div class="spacer"></div>


    <div><img src="assets/images/check-list.png" alt=""> <p>English</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Verbal Reasoning</p></div>
    <div><img src="assets/images/check-list.png" alt=""> <p>Mathematics</p></div>
    <div><img src="assets/images/check-list.png" alt=""> <p>Non-Verbal Reasoning (including Spatial Reasoning)</p></div>

    <div class="spacer"></div>

    <p>You will receive the results of your child’s 11+ exam online in October, and final Year 7 place allocations will be published in March.</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Slough 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

    <p>Grammar schools in Slough use the GL Assessment 11+ exam to assess pupils’ English, Verbal Reasoning, Mathematics and Non-Verbal Reasoning (including Spatial Reasoning) skills. Considered an essential part of the school’s admissions process, the examination is demanding and pupils are admitted on the grounds of their performance. <br> <br>

 

      The minimum required (standardised) score for the Slough 11+ exam is 111. Pupils who are able to score 80%+ consistently in our 11+ practice tests should be on track to pass the 11+ Slough Consortium test. <br>
      
       
      
      Whilst there are no guarantees, this has historically been a fairly strong indicator that your child should do well in the Slough 11+ exam. <br>
      
       
      
      Passing the test does not guarantee that your child will be offered a place. It simply means they have surpassed the required threshold. As such, it makes sense to aim for as high a score as possible. <br> <br>
      
       
      
      Don’t worry if your child is not scoring well in our practice papers from the outset. With targeted practice and focus, it’s possible to make big improvements in a short amount of time!</p>



    
      <div class="spacer"></div>

    <div class="spacer"></div>

    <h2>Slough Grammar Schools: Results & Leavers’ Destinations</h2>

    <div class="spacer"></div>

    <p> <strong>Slough Grammar Schools – Progress 8 Scores</strong> <br> <br>
      Progress 8 is a measure used to assess the progress made by students between the end of primary school (Key Stage 2) and the end of secondary school (Key Stage 4). It is a way of evaluating the value that schools add to their students’ education based on their academic progress. <br> <br>
      
       
      
      The Progress 8 score is calculated by comparing the actual achievements of students in eight key subjects (including English, mathematics, sciences, humanities and languages) to their expected achievements, which are based on their prior attainment at the end of primary school. The score is then determined by the average progress made by students across these subjects.</p>

      <div class="spacer"></div>
      <div class="spacer"></div>


      <h2>Slough 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

    <p>Grammar schools in Slough use the GL Assessment 11+ exam to assess pupils’ English, Verbal Reasoning, Mathematics and Non-Verbal Reasoning (including Spatial Reasoning) skills. Considered an essential part of the school’s admissions process, the examination is demanding and pupils are admitted on the grounds of their performance. <br> <br>

 

      The minimum required (standardised) score for the Slough 11+ exam is 111. Pupils who are able to score 80%+ consistently in our 11+ practice tests should be on track to pass the 11+ Slough Consortium test. <br> <br>
      
       
      
      Whilst there are no guarantees, this has historically been a fairly strong indicator that your child should do well in the Slough 11+ exam.<br> <br>
      
       
      
      Passing the test does not guarantee that your child will be offered a place. It simply means they have surpassed the required threshold. As such, it makes sense to aim for as high a score as possible.<br> <br>
      
       
      
      Don’t worry if your child is not scoring well in our practice papers from the outset. With targeted practice and focus, it’s possible to make big improvements in a short amount of time!</p>



    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Slough Grammar Schools: Results & Leavers’ Destinations </h2>

    <p> <strong>Slough Grammar Schools – Progress 8 Scores</strong> <br> <br>
      Progress 8 is a measure used to assess the progress made by students between the end of primary school (Key Stage 2) and the end of secondary school (Key Stage 4). It is a way of evaluating the value that schools add to their students’ education based on their academic progress. <br> <br>
      
       
      
      The Progress 8 score is calculated by comparing the actual achievements of students in eight key subjects (including English, mathematics, sciences, humanities and languages) to their expected achievements, which are based on their prior attainment at the end of primary school. The score is then determined by the average progress made by students across these subjects.
      
      </p>



    <div class="spacer"></div>

    <h2>Slough Grammar Schools – Leavers’ Destinations</h2>


    <p>Leavers’ destinations here refer to the next steps that students take after completing their studies at Slough grammar schools. <br> <br>

 

      Russell Group universities are highly sought-after educational institutions across the country, recognised for their exceptional performance across various benchmark indicators. These universities consistently excel in research output, boasting world-leading scholars and cutting-edge discoveries. Their academic reputation is stellar, attracting talented students from around the globe. <br><br>
      
       
      
      The University of Oxford and the University of Cambridge are members of the distinguished Russell Group. They are two of the oldest and most prestigious universities in the world, with a long history of academic excellence supported by rigorous academic programmes and distinguished faculty. <br>
      
       </p>

    <div class="spacer"></div>

    <div class="spacer"></div>

    <h2>Frequently Asked Questions About The 11 Plus (11+) Slough Grammar School Consortium </h2>

    <p> <strong>Does Slough have grammar schools?</strong>
 

      Yes, Slough has four selective grammar schools. Click here to access the articles we have for each of these schools, addressing their history and ethos, as well as all the details about their 11+ entry procedure. </p>

      <div class="spacer"></div>

    <div class="spacer"></div>

    <p> <strong>When is the Slough Grammar School Consortium 11+ exam held?</strong> <br> <br>
 

      Grammar schools in the Slough Consortium hold their 11+ exam in September. </p>



      <div class="spacer"></div>

      <div class="spacer"></div>
  
      <p> <strong>What is the format of the Slough Grammar School Consortium 11+ exam?</strong> <br> <br>
   
  
        The Slough 11+ exam consists of two papers which evaluate skills in the following areas: English, Verbal Reasoning, Mathematics and Non-Verbal Reasoning (including Spatial Reasoning). </p>


        <div class="spacer"></div>

      <div class="spacer"></div>
  
      <p> <strong>What is the pass mark at grammar schools in Slough?</strong> <br> <br>
   
  
        The minimum required (standardised) score for the Slough eleven plus exam is 111. Pupils who are able to score 80%+ consistently in our 11+ practice tests should be on track to pass the 11+ Slough Consortium test. </p>


  </div>

</div>

</div>